import { useMutation } from '@apollo/client'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { Data, DELETE_AB_TEST } from './api'
import { UseDeleteAbTest } from './types'

export const useDeleteAbTest = (): UseDeleteAbTest => {
  const { t } = useTranslation('features/abTests', {
    keyPrefix: 'list.actions.delete',
  })
  const { enqueueSnackbar } = useSnackbar()

  const [mutate, { loading }] = useMutation(DELETE_AB_TEST, {
    onCompleted: ({ errors }: Data): void => {
      if (errors && errors.length > 0) {
        enqueueSnackbar(t('error'), { variant: 'success' })
      } else {
        enqueueSnackbar(t('success'), { variant: 'success' })
      }
    },
    refetchQueries: ['getAbTests'],
  })

  const deleteAbTest = (id: string): void => {
    mutate({ variables: { input: { id } } })
  }

  return { deleteAbTest, loading }
}
